import MilitaryAviationProtectionPage from "./military-aviation-protection.page"

export default MilitaryAviationProtectionPage;
